function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import BrowserPersistence from '../../../util/simplePersistence';
import { clearCartDataFromCache } from '../../../Apollo/clearCartDataFromCache';
import { clearCustomerDataFromCache } from '../../../Apollo/clearCustomerDataFromCache';
import { createCart, getCartDetails, removeCart } from '../cart';
import { clearCheckoutDataFromStorage } from '../checkout';
import { Magento2 } from '../../../RestApi';
var {
  request
} = Magento2;
import actions from './actions';
import { getStoreCode } from "@magento/venia-ui/lib/components/StoreCodeRoute/storeCodeRoute";
var storage = new BrowserPersistence();
export var signOut = function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _thunk = _asyncToGenerator(function* (dispatch, _ref) {
      var {
        apolloClient
      } = _ref;
      var {
        revokeToken,
        fetchCartId,
        fetchCartDetails
      } = payload;
      if (revokeToken) {
        // Send mutation to revoke token.
        try {
          yield revokeToken();
        } catch (error) {
          console.error('Error Revoking Token', error);
        }
      }

      // Remove token from local storage and Redux.
      yield dispatch(clearToken());
      yield dispatch(actions.reset());
      yield clearCheckoutDataFromStorage();
      yield clearCartDataFromCache(apolloClient);
      yield clearCustomerDataFromCache(apolloClient);

      // Now that we're signed out, forget the old (customer) cart.
      // We don't need to create a new cart here because we're going to refresh
      // the page immediately after.
      yield dispatch(removeCart());
      yield dispatch(createCart({
        fetchCartId
      }));
      getCartDetails({
        fetchCartId,
        fetchCartDetails
      });
    });
    function thunk(_x, _x2) {
      return _thunk.apply(this, arguments);
    }
    return thunk;
  }();
};
export var getUserDetails = _ref2 => {
  var {
    fetchUserDetails
  } = _ref2;
  return /*#__PURE__*/function () {
    var _thunk2 = _asyncToGenerator(function* () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var [dispatch, getState] = args;
      var {
        user
      } = getState();
      if (user.isSignedIn) {
        dispatch(actions.getDetails.request());
        try {
          var {
            data
          } = yield fetchUserDetails({
            fetchPolicy: 'no-cache'
          });
          var _user = dispatch(actions.getDetails.receive(data.customer));
          setCurrentUser(_user);
          return data;
        } catch (error) {
          dispatch(actions.getDetails.receive(error));
        }
      }
    });
    function thunk() {
      return _thunk2.apply(this, arguments);
    }
    return thunk;
  }();
};
export var shareUserWishlist = formValues => /*#__PURE__*/function () {
  var _thunk3 = _asyncToGenerator(function* () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var [dispatch] = args;
    var store = getStoreCode();
    var body = {
      share_wishlist: {
        emails: [{
          email: formValues.email2
        }],
        comments: ''
      }
    };
    dispatch(actions.shareToWishlist.request());
    try {
      var response = yield request("/rest/".concat(store, "/V1/wishlist/share"), {
        method: 'POST',
        body: JSON.stringify(body)
      });
      yield dispatch(actions.shareToWishlist.receive(response));
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error(error);
        throw error;
      }
    }
  });
  function thunk() {
    return _thunk3.apply(this, arguments);
  }
  return thunk;
}();
export var getListByToken = token => /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* (dispatch) {
    var store = getStoreCode();
    if (!token) {
      return;
    }
    dispatch(actions.wishlistShare.request());
    try {
      var response = yield request("/rest/".concat(store, "/V1/wishlist/shared/").concat(token), {
        method: 'GET'
      });
      var _reponse = JSON.parse(response);
      _reponse = _objectSpread(_objectSpread({}, _reponse.data), {}, {
        title: _reponse.title,
        noItemsMessage: _reponse.noItemsMessage
      });
      dispatch(actions.wishlistShare.receive(_reponse));
    } catch (error) {
      //await signOut({ revokeToken })(dispatch);
      if (process.env.NODE_ENV === 'development') {
        console.error(error);
        throw error;
      }
    }
  });
  function thunk(_x3) {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}();
export var resetPassword = _ref3 => {
  var {
    email
  } = _ref3;
  return /*#__PURE__*/function () {
    var _thunk5 = _asyncToGenerator(function* () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var [dispatch] = args;
      dispatch(actions.resetPassword.request());

      // TODO: actually make the call to the API.
      // For now, just return a resolved promise.
      yield Promise.resolve(email);
      dispatch(actions.resetPassword.receive());
    });
    function thunk() {
      return _thunk5.apply(this, arguments);
    }
    return thunk;
  }();
};
export var setToken = token => /*#__PURE__*/function () {
  var _thunk6 = _asyncToGenerator(function* () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    var [dispatch] = args;

    // Store token in local storage.
    // TODO: Get correct token expire time from API
    storage.setItem('signin_token', token, 3600);

    // Persist in store
    dispatch(actions.setToken(token));
  });
  function thunk() {
    return _thunk6.apply(this, arguments);
  }
  return thunk;
}();
export var clearToken = () => /*#__PURE__*/function () {
  var _thunk7 = _asyncToGenerator(function* () {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    var [dispatch] = args;

    // Clear token from local storage
    storage.removeItem('signin_token');
    storage.removeItem('currentUserData');
    // Remove from store
    dispatch(actions.clearToken());
  });
  function thunk() {
    return _thunk7.apply(this, arguments);
  }
  return thunk;
}();
export function setCurrentUser(_x4) {
  return _setCurrentUser.apply(this, arguments);
}
function _setCurrentUser() {
  _setCurrentUser = _asyncToGenerator(function* (user) {
    return storage.setItem('currentUserData', user, 3600);
  });
  return _setCurrentUser.apply(this, arguments);
}